import { Component, OnInit, ViewChild, Optional, Output, EventEmitter } from '@angular/core';
import { UserService } from '../../services/user.service';
import { PaginationInstance } from '@farris/ui-pagination';
import { DataTableComponent } from '@farris/ui-datatable';
import { NotifyService } from '@farris/ui-notify';
import { DialogComponent } from '@farris/ui-dialog';
import { I18nService } from '../../services/i18n.service';

@Component({
  selector: 'wf-user-helper',
  templateUrl: './user-helper.component.html',
  styleUrls: ['./user-helper.component.css']
})
export class UserHelperComponent implements OnInit {

  private pageList = [10, 20, 30, 50, 100];
  paginationOptions: PaginationInstance = {
    id: 'WF-Users-DataTable-Pagination',
    currentPage: 1,
    itemsPerPage: 10,
    pageList: this.pageList,
    totalItems: 0
  };
  columns = [
    { title: this.i18nService ? this.i18nService.getValue('static.columnName.code') : '编号', field: 'Code', width: 80 },
    { title: this.i18nService ? this.i18nService.getValue('static.columnName.name') : '姓名', field: 'Name', width: 90 },
    { title: this.i18nService ? this.i18nService.getValue('static.columnName.department') : '部门', field: 'OrgName', width: 200 }];

  searchValue = null;
  userListData = [];
  // 是否允许多选,默认多选
  singleSelect = false;
  selectedUsers: {
    ID: string,
    Code: string,
    Name: string,
    OrgId: string,
    OrgName: string
  }[] = [];
  @ViewChild('allUserTable') userTable: DataTableComponent;
  @ViewChild('allUserDialog') userDialog?: DialogComponent;
  constructor(
    @Optional() protected i18nService: I18nService,
    protected userSvc: UserService,
    protected notify?: NotifyService,
  ) { }

  @Output()
  completed = new EventEmitter<boolean>();
  
  ngOnInit() {
  }

  handleOk(): void {
    throw new Error('没有实现，需要子组件实现');
  }

  handleCancel(): void {
    this.completed.emit(false);
    this.showModal(false);
  }

  onPageSizeChange(pageSize) {
    this.paginationOptions.itemsPerPage = pageSize;
    this.getUserList();
  }

  onPageChange(event) {
    this.paginationOptions.currentPage = event.pageIndex;
    this.getUserList();
  }

  protected getUserList() {
    this.userSvc.getUserList(this.searchValue, this.paginationOptions.currentPage, this.paginationOptions.itemsPerPage)
      .subscribe((re: { totalCount: number, data: any[] }) => {
        this.paginationOptions.totalItems = re.totalCount;
        this.userListData = re.data.map(u => ({
          ID: u.id,
          Code: u.code,
          Name: u.name,
          OrgId: u.sysOrgId,
          OrgName: u.sysOrgName,
          Checked: false
        }));
    });
  }

  search(event) {
    this.paginationOptions.currentPage = 1;
    this.searchValue = encodeURIComponent(event.value);

    if (event.field === '*') {
      this.getUserList();
    } else if (event.field === 'Name') {
      this.getUserList();
    } else {
      this.notify.warning('只支持用户名称过滤！');
    }
  }

  protected showModal(show: boolean): void {
    if (show) {
      this.userDialog.show();
      this.getUserList();
    } else {
      // 临时处理方案
      if (this.userDialog.beforeClose) {
        this.userDialog.close();
      }
    }
  }
}
